<div class="loading-spinner-container" *ngIf="loading$ | async">
  <app-loading-spinner></app-loading-spinner>
</div>
